// extracted by mini-css-extract-plugin
export default {"backButton":"gvRRfq3jdSGt8oxTbWcJ","tabsBox":"nUgjqMAM4BF6RoXjbUPH"};